import { createAction, props } from '@ngrx/store';
import { CreateMassRerateRequestModel } from '@shared/models/create-mass-rerate-request.model';
import { CreateMassRerateModel } from '@shared/models/create-mass-rerate.model';
import { ErrorModel } from '@shared/models/error';
import { GetMrraListRequestModel } from '@shared/models/get-mrra-list-request.model';
import { MrraGridFiltersModel } from '@shared/models/mrra-grid-filters.model';
import { MrraListModel, MrraStatusCountModel } from '@shared/models/mrra-list.model';
import { MrraTraySummaryModel } from '@shared/models/mrra-tray-summary.model';
import { ProgressMassRerateRequestModel } from '@shared/models/progress-mass-rerate-request.model';
import { ProgressMassRerateResponseModel } from '@shared/models/progress-mass-rerate-response.model';
import { ProgressReratePathParamsModel } from '@shared/models/progress-rerate-path-params.model';
import { UpdateMassReratePathParamsModel } from '@shared/models/update-mass-rerate-path-params.model';
import { UpdateMassRerateRequestModel } from '@shared/models/update-mass-rerate-request.model';
import { UpdateMassRerateModel } from '@shared/models/update-mass-rerate.model';
import { CustomerMatch } from '@xpo-ltl-2.0/sdk-customer';
import { CreateAdhocMassRerateResp, CreateAdhocMassRerateRqst } from '@xpo-ltl-2.0/sdk-rating';
import { WhatIfDownloadFileTypeCd } from '@xpo-ltl/sdk-common';

export abstract class MrraActions {
  static clearMrraStore = createAction('[MrraActions] Clear Mrra Store');

  static createMassRerate = createAction(
    '[MrraActions] Create an adhoc Mass Rerate Request',
    props<{ request: CreateAdhocMassRerateRqst }>()
  );
  static createMassRerateSuccess = createAction(
    '[MrraActions] Create an adhoc Mass Rerate Request Success',
    props<{ createMassRerateResp: CreateAdhocMassRerateResp }>()
  );
  static createMassRerateFail = createAction(
    '[MrraActions] Create an adhoc Mass Rerate Request Fail',
    props<{ errors: ErrorModel[] }>()
  );

  static listMassRerate = createAction(
    '[MrraActions] List Mass Rerate Requests',
    props<{ request: GetMrraListRequestModel }>()
  );

  static listMassRerateSuccess = createAction(
    '[MrraActions] List Mass Rerate Requests Success',
    props<{ mrraList: MrraListModel}>()
  );

  static listMassRerateFail = createAction(
    '[MrraActions] List Mass Rerate Requests Fail',
    props<{ errors: ErrorModel[] }>()
  );

  static createNewMassRerateRequest = createAction(
    '[MrraActions] Create a new Mass Rerate Request',
    props<{ createMassRerateRequest: CreateMassRerateRequestModel }>()
  );
  static createNewMassRerateRequestSuccess = createAction(
    '[MrraActions] Create a new Mass Rerate Request Success',
    props<{ createdNewMassRerate: CreateMassRerateModel }>()
  );
  static createNewMassRerateRequestFail = createAction(
    '[MrraActions] Create a new Mass Rerate Request Fail',
    props<{ errors: ErrorModel[] }>()
  );

  static progressMassRerateRequest = createAction(
    '[MrraActions] Progress a Mass Rerate Request',
    props<{ progressMassRerateRequest: ProgressMassRerateRequestModel, progressReratePathParams: ProgressReratePathParamsModel }>()
  );
  static progressMassRerateRequestSuccess = createAction(
    '[MrraActions] Progress a Mass Rerate Request Success',
    props<{ progressMassRerateResp: ProgressMassRerateResponseModel }>()
  );
  static progressMassRerateRequestFail = createAction(
    '[MrraActions] Progress a Mass Rerate Request Fail',
    props<{ errors: ErrorModel[] }>()
  );

  static updateMassRerateRequest = createAction(
    '[MrraActions] Update a Mass Rerate Request',
    props<{ updateMassRerateRequest: UpdateMassRerateRequestModel, updateMassReratePathParams: UpdateMassReratePathParamsModel }>()
  );
  static updateRerateRequestSuccess = createAction(
    '[MrraActions] Update a Mass Rerate Request Success',
    props<{ updatedMassRerate: UpdateMassRerateModel }>()
  );
  static updateRerateRequestFail = createAction(
    '[MrraActions] Update a Mass Rerate Request Fail',
    props<{ errors: ErrorModel[] }>()
  );
  
  static setGridFilters = createAction(
    '[MrraActions] Set Grid Filters',
    props<{ filters: MrraGridFiltersModel }>()
  );

  static setWhatIfRequestActions = createAction(
    '[MrraActions] Set What-if Request Actions',
    props<{ whatIfRequestData: MrraTraySummaryModel }>()
  );

  static mrraRequestsDownloadShipmentFile = createAction(
    '[MrraActions] Download Mrra Request Shipment File',
    props<{ fileId: string, whatIfDownloadFileTypeCd: WhatIfDownloadFileTypeCd }>()
  );

  static mrraRequestsDownloadShipmentFileSuccess = createAction(
    '[MrraActions] Download Mrra Request Shipment File Success',
    props<{ fileData: string }>()
  );

  static mrraRequestsDownloadShipmentFileFail = createAction(
    '[MrraActions] Download Mrra Request Shipment File Fail',
    props<{ errors: ErrorModel[] }>()
  );
  
  static setStatusCountsActions = createAction(
    '[MrraActions] Set Status Counts Actions',
    props<{ mrraStatusCounts: MrraStatusCountModel[] }>()
  );

  static mrraGetAccountsFiltered = createAction(
    '[MrraActions] Get filtered',
    props<{ filterData: string }>()
  );

  static mrraGetAccountsFilteredSuccess = createAction(
    '[MrraActions] Get filtered Success',
    props<{ accounts: CustomerMatch[] }>()
  );
  
  static mrraGetAccountsFilteredFail = createAction(
    '[MrraActions] Get filtered Fail',
    props<{ errors: ErrorModel[] }>()
  );
  
  static mrraGetAccountsOverrideFiltered = createAction(
    '[MrraActions] Get Override filtered',
    props<{ filterData: string }>()
  );

  static mrraGetAccountsOverrideFilteredSuccess = createAction(
    '[MrraActions] Get Override filtered Success',
    props<{ accounts: CustomerMatch[] }>()
  );

  static mrraGetAccountsOverrideFilteredFail = createAction(
    '[MrraActions] Get Override filtered Fail',
    props<{ errors: ErrorModel[] }>()
  );
}
